import { ADD_CAR, REMOVE_CAR, CLEAR_CAR } from '../actions';

export default function(state=null, action){
  let carrito = state;
  if (state==null) {
    if(null!=localStorage.getItem("carrito")){
      return JSON.parse(localStorage.getItem("carrito"));
    }else{
      return {};
    }
  }

  switch (action.type) {
    case ADD_CAR:
      //se copia el producto en una nueva variable
      let prod = Object.assign({}, action.payload);
      //se eliminan los datos inecesarios
      delete prod['modulos'];
      delete prod['modulos_libres'];
      //se copia es state en una nueva variable (para evitar devolver el mismo state)
      carrito = Object.assign({}, state);
      //se agrega el producto a la copia
      carrito[prod.id] = prod;
      break;
    case REMOVE_CAR:
      //se realiza una copa del state
      carrito = Object.assign({}, state);
      //se elimina el producto especificado de la copia
      delete carrito[action.payload];
      break;
    case CLEAR_CAR:
      //se devuelve un nuevo objeto vacío
      carrito = {};
      break;
    default:
      //no se hace nada, se devuelve el mismo state
      return state;
  }
  //se almacena en el almacenamiento del navegador el carrito
  localStorage.setItem("carrito", JSON.stringify(carrito));
  return carrito;
}



// WEBPACK FOOTER //
// ./src/reducers/carrito_reducer.js